export enum BedtimeShift {
  DELAY_BEDTIME = 'delay',
  SLEEP_EARLIER = 'advance'
}
